import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

const LS_KEY = "maldek.installPrompt.dismissed";

export default function InstallAppPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [showIOS, setShowIOS] = useState(false);

  useEffect(() => {
    try {
      if (localStorage.getItem(LS_KEY) === "1") return;
    } catch { /* noop */ }
    const standalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone === true;
    if (standalone) return;

    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);

    const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent);
    let t;
    if (isIOS) t = setTimeout(() => setShowIOS(true), 8000);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      clearTimeout(t);
    };
  }, []);

  const dismiss = () => {
    try { localStorage.setItem(LS_KEY, "1"); } catch { /* noop */ }
    setDeferred(null);
    setShowIOS(false);
  };

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice.catch(() => {});
    dismiss();
  };

  if (!deferred && !showIOS) return null;
  return (
    <div
      data-testid="install-app-prompt"
      className="no-print fixed bottom-16 left-1/2 -translate-x-1/2 z-[9998] flex items-center gap-3 rounded-2xl px-4 py-3 shadow-2xl max-w-[92vw]"
      style={{ background: "#2b261c", border: "1px solid rgba(107,143,113,0.3)" }}
    >
      <Download className="h-4 w-4 shrink-0" style={{ color: "#6B8F71" }} />
      {deferred ? (
        <>
          <span className="text-[13px] text-white/90">Install Maldek by Hill as an app — studies work even offline</span>
          <button
            onClick={install}
            data-testid="install-app-btn"
            className="rounded-full px-4 py-1.5 text-[12px] font-bold shrink-0"
            style={{ background: "#6B8F71", color: "#0d1629" }}
          >
            Install
          </button>
        </>
      ) : (
        <span className="text-[13px] text-white/90">
          Install this app: tap <span className="font-bold">Share</span> → <span className="font-bold">Add to Home Screen</span>
        </span>
      )}
      <button onClick={dismiss} data-testid="install-app-dismiss" aria-label="Dismiss" className="shrink-0 text-white/50 hover:text-white">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
